const {
	base_path,
	base_path_portal,
	base_path_api,
	base_path_resources,
	gtm_code,
	fireConfig,
} = window["runConfig"]

export const PORTAL_URL = ""
export const BASE_PATH = base_path
export const BASE_PATH_PORTAL = base_path_portal
export const BASE_FIRE_CONFIG = fireConfig
export const BASE_PATH_API = base_path_api
export const BASE_PATH_RESOURCES = base_path_resources
export const BASE_URL_PORTAL = "https://pwa-beta.dev.sears.com.mx"
export const GTM_CODE = gtm_code
export const NO_IMAGE = `${BASE_PATH_RESOURCES}/medios-plazavip/swift/v1/assets/img/noImage.png`
export const WHITE_PIXEL = `/img/whitePixel.svg`
export const TIMEOUT_TIME = 100000